export default [
  {
    path: '/summary/:key?',
    name: 'summaryIndex',
    component: () => import('@/views/summary/SummaryIndex.vue'),
    meta: {},
  },
];
